
<template>
  <div class="row text-left justify-content-center">
    <div class="col-12 col-md-10 col-xl-8 news">
      <h1 class="my-4">News<img :src="require('@/assets/images/icons/menu/news.png')"/></h1>
      <p>A place to find the latest news related to MayhemSpells!</p>
      <h1>Patch Notes</h1>
      
    </div>
  </div>
</template>
<style>
.news > h2 {
  margin-top: 20px;
}
</style>
<script>

export default {
  name: 'NewsPage',
  props: {
    app: Object
  },
  computed: {
  }
}
</script>
